__turbopack_context__.v({
  "contentWrapper": "FormSurvey-module__OyZP6W__contentWrapper",
  "formSurveyWrapper": "FormSurvey-module__OyZP6W__formSurveyWrapper",
});
